module.exports = __webpack_public_path__ + "img/06.f8c2b12b.jpg";